import { render } from "./patient-progression.vue?vue&type=template&id=13910b20&scoped=true"
import script from "./patient-progression.vue?vue&type=script&lang=js"
export * from "./patient-progression.vue?vue&type=script&lang=js"

import "./patient-progression.vue?vue&type=style&index=0&id=13910b20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13910b20"]])

export default __exports__